import { ChartJsBar } from "./base";

const Line: typeof ChartJsBar = ({ data, ...props }) => (
  <ChartJsBar data={data} {...props} />
);

export default Line;
